import { ZodObject } from 'zod';

export function isSchemaIncludeAnOther(parentSchema: ZodObject, schema: ZodObject): boolean {
  return Object.keys(schema.shape).every(key => key in parentSchema.shape);
}